<template>
  <div id="myCarousel" class="carousel slide mb-6" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" class="active" aria-current="true"
        aria-label="Slide 1"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
    </div>
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img :src="require('@/assets/landingpage/202512_landingpage_001.png')" class="carousel-img mx-auto d-block" />
        <div class="container">
          <div class="carousel-caption text-start">
            <h1>Ein Dashboard für alles</h1>
            <p class="opacity-75">
              Überwachen und steuern Sie alle Ihre Anlagen zentral. Eine Plattform für Solar, Windkraft, Biogas und mehr.
            </p>
          </div>
        </div>
      </div>
      <div class="carousel-item">
        <img :src="require('@/assets/landingpage/202512_landingpage_002.png')" class="carousel-img mx-auto d-block" />
        <div class="container">
          <div class="carousel-caption">
            <h1>Another example headline.</h1>
            <p>
              Some representative placeholder content for the second slide
              of the carousel.
            </p>
          </div>
        </div>
      </div>
      <div class="carousel-item">
        <img :src="require('@/assets/landingpage/202512_landingpage_003.png')" class="carousel-img mx-auto d-block" />
        <div class="container">
          <div class="carousel-caption text-end">
            <h1>Detaillierte Auswertungen</h1>
            <p>
              Analysieren Sie Ihre kompletten Anlagendaten und exportieren Sie Ihre Ergebnisse für weitere Auswertungen.
            </p>
          </div>
        </div>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
  <!-- Marketing messaging and featurettes
  ================================================== -->
  <!-- Wrap the rest of the page in another container to center all the content. -->
  <div class="container marketing">
    <!-- Three columns of text below the carousel -->
    <div class="row">
      <div class="col-lg-4">
        <div class="feature-icon-container rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
          <i class="fa-solid fa-chart-line fa-4x text-primary"></i>
        </div>
        <h2 class="fw-normal">Echtzeit-Monitoring</h2>
        <p>
          Überwachen Sie alle Ihre Anlagen in Echtzeit. Behalten Sie wichtige Kennzahlen im Blick und reagieren Sie sofort auf Veränderungen.
        </p>
      </div>
      <!-- /.col-lg-4 -->
      <div class="col-lg-4">
        <div class="feature-icon-container rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
          <i class="fa-solid fa-bell fa-4x text-warning"></i>
        </div>
        <h2 class="fw-normal">Alarmmeldungen</h2>
        <p>
          Werden Sie automatisch über kritische Ereignisse informiert. Konfigurieren Sie individuelle Benachrichtigungen für Ihre Anforderungen.
        </p>
      </div>
      <!-- /.col-lg-4 -->
      <div class="col-lg-4">
        <div class="feature-icon-container rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
          <i class="fa-solid fa-chart-bar fa-4x text-success"></i>
        </div>
        <h2 class="fw-normal">Reports & Analysen</h2>
        <p>
          Erstellen Sie automatisierte Reports und analysieren Sie Ihre Anlagendaten über beliebige Zeiträume. Exportieren Sie Daten für weitere Auswertungen.
        </p>
      </div>
      <!-- /.col-lg-4 -->
    </div>
    <!-- /.row -->

  </div>
</template>

<script setup>

</script>

<style>
/* Carousel base class */
.carousel {
  margin-bottom: 4rem;
}

/* Since positioning the image, we need to help out the caption */
.carousel-caption {
  bottom: 3rem;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 2rem;
  border-radius: 0.5rem;
  backdrop-filter: blur(5px);
}

.carousel-caption h1 {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
  font-weight: 700;
}

.carousel-caption p {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
}

/* Declare heights because of positioning of img element */
.carousel-item {
  height: 32rem;
}


/* MARKETING CONTENT
-------------------------------------------------- */

/* Center align the text within the three columns below the carousel */
.marketing .col-lg-4 {
  margin-bottom: 1.5rem;
  text-align: center;
}

.feature-icon-container {
  width: 140px;
  height: 140px;
  background-color: #f8f9fa;
  border: 2px solid #dee2e6;
}

/* rtl:begin:ignore */
.marketing .col-lg-4 p {
  margin-right: .75rem;
  margin-left: .75rem;
}

/* rtl:end:ignore */


/* Featurettes
------------------------- */

.featurette-divider {
  margin: 5rem 0;
  /* Space out the Bootstrap <hr> more */
}

/* Thin out the marketing headings */
/* rtl:begin:remove */
.featurette-heading {
  letter-spacing: -.05rem;
}

/* rtl:end:remove */

/* RESPONSIVE CSS
-------------------------------------------------- */

@media (min-width: 40em) {

  /* Bump up size of carousel content */
  .carousel-caption p {
    margin-bottom: 1.25rem;
    font-size: 1.25rem;
    line-height: 1.4;
  }

  .featurette-heading {
    font-size: 50px;
  }
}

@media (min-width: 62em) {
  .featurette-heading {
    margin-top: 7rem;
  }
}

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

.b-example-divider {
  width: 100%;
  height: 3rem;
  background-color: #0000001a;
  border: solid rgba(0, 0, 0, 0.15);
  border-width: 1px 0;
  box-shadow:
    inset 0 0.5em 1.5em #0000001a,
    inset 0 0.125em 0.5em #00000026;
}

.b-example-vr {
  flex-shrink: 0;
  width: 1.5rem;
  height: 100vh;
}

.bi {
  vertical-align: -0.125em;
  fill: currentColor;
}

.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.btn-bd-primary {
  --bd-violet-bg: #712cf9;
  --bd-violet-rgb: 112.520718, 44.062154, 249.437846;
  --bs-btn-font-weight: 600;
  --bs-btn-color: var(--bs-white);
  --bs-btn-bg: var(--bd-violet-bg);
  --bs-btn-border-color: var(--bd-violet-bg);
  --bs-btn-hover-color: var(--bs-white);
  --bs-btn-hover-bg: #6528e0;
  --bs-btn-hover-border-color: #6528e0;
  --bs-btn-focus-shadow-rgb: var(--bd-violet-rgb);
  --bs-btn-active-color: var(--bs-btn-hover-color);
  --bs-btn-active-bg: #5a23c8;
  --bs-btn-active-border-color: #5a23c8;
}

.bd-mode-toggle {
  z-index: 1500;
}

.bd-mode-toggle .bi {
  width: 1em;
  height: 1em;
}

.bd-mode-toggle .dropdown-menu .active .bi {
  display: block !important;
}

.carousel-img {
  height: 500px;
  /* feste Carousel-Höhe */
  object-fit: contain;
  /* komplettes Bild sichtbar */
}
</style>
